/* Subtle scroll parallax for large photography (hero background, category
   cards) — inspired by gudlife.mx's use of parallax on its diorama-style
   product photography. transform-only, rAF-throttled scroll listener,
   skipped entirely under prefers-reduced-motion. Each target's own CSS
   oversizes it (114%/-7%) so the shift never exposes an edge. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var TARGETS = [
    { selector: '.tm-hero-bg-media', speed: 0.12 },
    { selector: '.tm-category-media', speed: 0.1 }
  ];

  // Each target's CSS oversizes it by 14% (114% height, -7% top) so it has
  // room to shift. Clamp to 6% of the *container's* height (a hair under
  // that 7% buffer) so a fast scroll or a short viewport can never push it
  // far enough to expose an edge.
  var MAX_SHIFT_RATIO = 0.06;

  var els = [];
  TARGETS.forEach(function (t) {
    document.querySelectorAll(t.selector).forEach(function (el) {
      els.push({ el: el, speed: t.speed, container: el.parentElement });
    });
  });
  if (!els.length) return;

  var ticking = false;

  function update() {
    var vh = window.innerHeight;
    els.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var centerOffset = rect.top + rect.height / 2 - vh / 2;
      var maxShift = item.container.getBoundingClientRect().height * MAX_SHIFT_RATIO;
      var shift = centerOffset * -item.speed;
      shift = Math.max(-maxShift, Math.min(maxShift, shift));
      item.el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
    });
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
